var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:`el-icon-${_vm.status}`,style:({ color: _vm.colors[_vm.status], fontSize: '20px', marginRight: '10px' })})
}
var staticRenderFns = []

export { render, staticRenderFns }